"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = exports.StyledIcon = exports.Wrapper = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _Icon = _interopRequireDefault(require("../../../IconicDisplayElements/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "PolicyStatusstyles__Wrapper",
  componentId: "sc-1am8rdv-0"
})(["align-items:center;display:flex;"]);

exports.Wrapper = Wrapper;
var StyledIcon = (0, _styledComponents.default)(function (props) {
  return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _omit.default)(props, ['noBorder']));
}).withConfig({
  displayName: "PolicyStatusstyles__StyledIcon",
  componentId: "sc-1am8rdv-1"
})(["  border-radius:100%;border:", ";box-sizing:content-box;"], function (props) {
  return props.noBorder ? 'unset' : "3px solid ".concat(props.theme.c_background_default);
});
exports.StyledIcon = StyledIcon;

var Content = _styledComponents.default.div.withConfig({
  displayName: "PolicyStatusstyles__Content",
  componentId: "sc-1am8rdv-2"
})(["font-size:1rem;font-weight:", ";margin-left:", ";"], function (props) {
  return props.theme.primaryNormal;
}, function (props) {
  return props.theme.standardPadding;
});

exports.Content = Content;